import sStorage from './storage';
import store from "../store";

class TokenService {

	getUser() {
		try {
			let user = sStorage.getItem('stored');
			if (!user) {
				return null;
			}
			return user;
		}
		catch (e) {
			console.log('getUser', e);
			this.removeUser();
			return null;
		}
	}

	setUser(user) {
		sStorage.setItem('stored', user);
	}

	removeUser() {
		sStorage.clear();
	}

	getLocalAccessToken() {
		let user = this.getUser();
		return user?.jwtToken;
	}

	updateCompany(companyID) {
		let user = this.getUser();
		if (user) {
			user.companyID = companyID;
			this.setUser(user);
		}
	}

	updateToken(data) {
		let user = this.getUser();
		if (user) {
			user.jwtToken = data.jwtToken;
			this.setUser(user);
		}
		else {
			this.setUser(data);
		}
		////store.dispatch('auth/refreshLoginFailed');
	}

}

export default new TokenService();
